import axios from 'axios';
import { Config }   from './configActions';
export const FETCH_QUESTAO_APROVAR   = 'FETCH_QUESTAO_APROVAR';
export const FETCH_QUESTAO_PROFESSOR = 'FETCH_QUESTAO_PROFESSOR';
export const FETCH_EDITAR_QUESTAO    = 'FETCH_EDITAR_QUESTAO';
export const FETCH_QUESTAO_JOGO      = 'FETCH_QUESTAO_JOGO';
export const ADD_QUESTAO_APROVAR     = 'ADD_QUESTAO_APROVAR';
export const ADD_QUESTAO_PROFESSOR   = 'ADD_QUESTAO_PROFESSOR';

var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
 Config();


 export function GetByAprovarQuestoesDuelo(usu_id) {
   	

    const request =  axios.get(`/api/duelos/questoes/aprovar/lista/${usu_id}`,Authorization);
 
    return{
           type    : FETCH_QUESTAO_APROVAR,
           payload : request
        };

}


export function SetByCadastrarQuestaoDuelo(data,usu_id,per_id,due_que_id,usu_id_edicao){

	
	const aprovar = (per_id  === 2 ? 1:null);
	const aprovou = (per_id  === 2 ? usu_id:null);
	const acao = (due_que_id === 0
                            ? {
                                            method: axios.post,
                                            rota: "/api/duelos/cadastrar/questao"
                            }
                            : {
                                            method: axios.post,
                                            rota: "/api/duelos/questoes/atualizar"
                            });
     const usuAcao = (usu_id_edicao ===0 ? usu_id : usu_id_edicao);

       return dispatch => {
       
       const rota = acao.rota;    
	   return acao.method(rota, {
                                    due_que_id             : due_que_id,
                                    due_que_pergunta       : data.cad_questao_duelo,
                                    due_que_opcao_a        : data.cad_questao_a,
                                    due_que_opcao_b        : data.cad_questao_b,
                                    due_que_opcao_c        : data.cad_questao_c,
                                    due_que_opcao_d        : data.cad_questao_d,
                                    due_que_resposta       : data.optionQuestao,
                                    due_que_cod_usuario    : usuAcao,
                                    due_que_cod_aprovou    : aprovou,
                                    due_que_flag_aprovar   : aprovar,
                                    due_que_cod_disciplina : data.cad_questao_dis
                                    },Authorization);

       }
	

}

export function SetUploadFiles(due_que_id,file) {

    return dispatch => {
        const formData = new FormData();
        formData.append('due_que_anexo', file[0]);
        formData.append('due_que_id', due_que_id);
        return axios.post('/api/duelos/questoes/upload', formData,Authorization);
    }

}

export function SetByAceitarRecusarQuestao(usu_id,que_id,acao) {

     return dispatch => {

       return axios.get(`/api/duelos/questoes/aprovar/${usu_id}/${que_id}/${acao}`,Authorization);
   
    }

}

export function EditarQuestao(param){

     return dispatch => {

       return axios.get(`/api/duelos/questoes/obter/questao/${param}`,Authorization);
   
    }
}

export function GetByQuestoesDuelo(usu_id,due_id){

   const request =  axios.get(`/api/duelos/questoes/${usu_id}/${due_id}`,Authorization);

   return{
           type    : FETCH_QUESTAO_JOGO,
           payload : request
        };

}

export function SetByResponderQuestao(usu_id,due_id,due_res_id,due_que_id,selectResposta){
    
    	
      return dispatch =>{
        
            return axios.post('/api/duelos/resposta',{
                                use_id:usu_id,
                                due_id:due_id,
                                due_res_id:due_res_id,
                                due_que_id:due_que_id,
                                due_que_resposta:selectResposta
                              },Authorization);
      }

}

export function GetQuestaoProfessor(usu_id){

  const request =  axios.get(`/api/duelos/questoes/usuario/listar/${usu_id}`,Authorization);
  return {
    type    : FETCH_QUESTAO_PROFESSOR,
    payload : request
  }

}



// WEBPACK FOOTER //
// ./src/actions/questaoActions.js